// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgCandlestickChart = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 16.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75M12 21.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75M19 13.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75M5 8.75A.75.75 0 0 1 4.25 8V6a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75M12 13.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75M19 5.75a.75.75 0 0 1-.75-.75V3a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.25 13.25v-4.5h-2.5v4.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V8.6c0-.746.604-1.35 1.35-1.35h2.8c.746 0 1.35.604 1.35 1.35zM13.25 18.25v-4.5h-2.5v4.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35h-2.8a1.35 1.35 0 0 1-1.35-1.35v-4.8c0-.746.604-1.35 1.35-1.35h2.8c.746 0 1.35.604 1.35 1.35zM20.25 10.25v-4.5h-2.5v4.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35h-2.8a1.35 1.35 0 0 1-1.35-1.35V5.6c0-.746.604-1.35 1.35-1.35h2.8c.746 0 1.35.604 1.35 1.35z"
      clipRule="evenodd"
    />
  </svg>
);
export const CandlestickChartIcon = forwardRef(SvgCandlestickChart);
